import "./operations.css";
import InputSelect from "../layouts/inputField/inputSelect/inputSelect";
import { useEffect, useState, useRef } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";
import getCurrentDateTime from "../layouts/getDate/getCurrentDateTime";

export default function Operations({
  operations,
  selectedRows,
  reportType,
  resetSelectedRows,
}) {
  const [disableState, setDisableState] = useState(true);

  const operationValue = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    setDisableState(selectedRows.length === 0);
  }, [selectedRows]);

  const onClick = async () => {
    //console.log(operationValue.current.value);
    //console.log(selectedRows.map(row => row.id));
    if (operationValue.current.value === "- Choose an operation -") {
      alert("Please select an operation");
    } else if (reportType === "CRF") {
      const zip = new JSZip();

      for (const row of selectedRows) {
        if (row.externalUrl) {
          try {
            const response = await fetch(row.externalUrl);
            if (!response.ok) throw new Error("Network response was not ok");
            const blob = await response.blob();
            const fileName = row.externalUrl.split("/").pop();
            zip.file(fileName, blob);
          } catch (error) {
            console.error("Fetch error:", error);
          }
        }
      }

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `CRF_DATA_${getCurrentDateTime()}.zip`);
      resetSelectedRows();
      operationValue.current.selectedIndex = 0;
    } else {
      navigate(`/curesickle/cde-details/${reportType}/${selectedRows.map(row => row.id)}`);
    }
  };

  return (
    <div className={`operations ${disableState ? "disabled" : ""}`}>
      <InputSelect
        id="operations"
        labelText="Operations"
        inputArr={operations}
        defaultVal="- Choose an operation -"
        ref={operationValue}
      />
      <button disabled={disableState} onClick={onClick}>
        Execute
      </button>
    </div>
  );
}
